import * as Yup from 'yup';

export const SeasonalCalendarFilterSchema = Yup.object({
  distributorOrgId: Yup.string(),
  distributorSiteId: Yup.string(),
});
